import script from "./prefactura.vue?vue&type=script&setup=true&lang=js"
export * from "./prefactura.vue?vue&type=script&setup=true&lang=js"

import "./prefactura.vue?vue&type=style&index=0&id=47d9429e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47d9429e"]])

export default __exports__